import { DealService } from './../newactive/services/deals.service';
import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, PopoverController, ViewController, AlertController, ModalController, IonicPage } from 'ionic-angular';
import { Http, Headers, RequestOptions } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireStorage } from 'angularfire2/storage';
import { LoadingProvider } from '../../providers/loading/loading';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SdfFormService } from '../../app/services/sdf-form-service';
import { AngularFireAuth } from 'angularfire2/auth';
import {EnvDataService} from '../../app/services/env-data-service';
import {AdfListService} from '../adf-page/services/adf-list.service';

export interface Image {
  id: string;
  image: string;
}

@IonicPage({
  segment:'view-deals/:deal_id'
})
@Component({
  selector: 'page-view-deal',
  templateUrl: 'view-deals.html',
  providers:[EnvDataService,AdfListService,DealService]
})
export class ViewDealPage implements AfterViewInit{

  /*Request form*/
  url: any;
  newImage: Image = {
    id: this.db.createId(), image: ''
  }
  loading: boolean = false;
  /*End Request form*/

  public user_data:any;
  public ac_deal_id:any;
  public ac_contact_id:any;
  public ac_files:any = [];
  public progressPercent = 20;
  public uploadProgress:number = 0;
  public acApiUrl:any;
  public acApiKey:any;
  public dealdetails:any;
  public contactdetails:any;
  public userdetails:any;  
  public notedetails:any = [];
  public ac_status:any;
  public paramdata:any;

  public dealsData: any;

  public validation_messages = {
    'email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ]
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http : Http,
    public db: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public toastCtrl: ToastController,
    public popoverCtrl: PopoverController,
    public formBuilder: FormBuilder,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    private storage: AngularFireStorage,
    public SdfFormService: SdfFormService,
    public afAuth: AngularFireAuth,
    public modalCtrl: ModalController,
    private EnvDataService:EnvDataService,
    public afdService:AdfListService,
    public _DealService:DealService
  ) {
  
      this.ac_contact_id = this.navParams.get("ac_contact_id");
      this.ac_deal_id = this.navParams.get("ac_deal_id");
      this.acApiKey = this.navParams.get("acApiKey");
      this.acApiUrl = this.navParams.get("acApiUrl"); //ac_status
      this.ac_status = this.navParams.get("ac_status"); 
      console.log(this.ac_contact_id);
      console.log(this.ac_deal_id);
      // this.afdService.getAllACfiles(this.ac_contact_id,this.ac_deal_id).then((data)=>{
      //   this.ac_files=data;
      // })
      // this.getActiveDealDetails(this.ac_contact_id,this.ac_deal_id);
  }

  ngAfterViewInit(){
    let thiss = this;
    this.navCtrl.viewDidEnter.subscribe(item=> {
      const viewController = item as ViewController;
      console.log(viewController);
      const pagename = viewController.name;
        // add active and corresponsing images
        thiss.paramdata = viewController.data;
        console.log(thiss.paramdata);
        this.getDeals();
    });
  }

  uploadImage(event) {

    console.log(event);
    debugger;
    const thiss = this;
    //uid = this.SDF_form_document_id;
    if (event.files.length > 0) {
      Object.keys(event.files).forEach(function(key) {
        let reader = new FileReader();
        reader.readAsDataURL(event.files[key]);
        reader.onload = (e:any) => {
          const fileraw = event.files[key]; //payslip_sallary /sallary_payslip/undefined
          // const filePath = '/sallary_payslip/' + uid + '/' + (Math.floor(1000 + Math.random() * 9000) + 1);
          const filePath = '/ac_files/undefined/' + (Math.floor(1000 + Math.random() * 9000) + 1);

          let filesize = event.files[key].size/1024/1024;
           if(filesize > 10) {
             
           }
           else {
              const result = thiss.SaveImageRef(filePath, fileraw);
              result.task.percentageChanges().subscribe(
                (value: number) => thiss.uploadProgress = value,
              );
            

              console.log(thiss.uploadProgress);
              const ref = result.ref;
              console.log(ref);

              result.task.then(a => {
                ref.getDownloadURL().subscribe(a => {
                  
                  let ac_obj = {
                    ac_downlink:a,
                    ac_filename:event.files[key].name,
                    ac_contact_id:thiss.ac_contact_id,
                    ac_deal_id:thiss.ac_deal_id,
                  }
                  let eventname = event.files[key].name;
                  if (thiss.ac_files.filter(a => a.name == eventname).length <= 0){
                      thiss.ac_files.push(ac_obj);
                    }

                    thiss.afdService.saveACFiles(ac_obj).then((data)=>{
                      console.log(data);
                      thiss.uploadProgress=0;
                    }) 
                  console.log(ac_obj);
                });
               
              });
              
           }
          
        }, error => {
          
        }
      });
         
    }
  }
  SaveImageRef(filePath, file) {
    return {
      task: this.storage.upload(filePath, file), 
      ref: this.storage.ref(filePath)
    };
  }
  acfiles_remove(downloadUrl) {
    let thiss = this;
    let alert = this.alertCtrl.create({
      title: 'Confirm remove payslip',
      message: 'Are you sure you want to remove this payslip ?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            thiss.afdService.deleteACFiles(downloadUrl).then((data)=>{
              thiss.delete(downloadUrl)
            }) 
            thiss.ac_files = thiss.ac_files.filter((item) => item.ac_downlink !== downloadUrl);
          }
        }
      ]
    });
    alert.present();
  }
  delete(downloadUrl) {
    return this.storage.storage.refFromURL(downloadUrl).delete();
  }
  getActiveDealDetails(ac_contact_id,ac_deal_id) {
    console.log(ac_contact_id);
  
    let thiss = this;
    console.log(this.user_data);
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    headers.append('Access-Control-Allow-Origin', '*' );
    headers.append('Api-Token', this.acApiKey );
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      "ac_deal_id":ac_deal_id,
      "ac_contact_id":ac_contact_id,
      "acApiKey":this.acApiKey,
      "acApiUrl":this.acApiUrl
    }
    console.log(postData);
    var url = this.EnvDataService.EnvData.sendbox_api+"/getActiveDealDetails";
    this.http.post(url, postData,requestOptions)
    .subscribe(data => {
      console.log('now working');
      console.log(data);
      let resdata =  JSON.parse(data['_body']);
      console.log(resdata);
      thiss.dealdetails = resdata.deals[0];
      thiss.contactdetails = resdata.contacts[0];
      thiss.userdetails = resdata.users[0];
      thiss.notedetails = resdata.notes;
      console.log(thiss.dealdetails);
      console.log(thiss.userdetails);
    }, error => {
     
    });
  }
  getDeals() {
    let thiss = this;
    this._DealService.getdealbyid(this.paramdata.deal_id).then((data)=>{
      console.log(data);
      thiss.dealsData= data;
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/view-deal/view-deals.ts